import styled, { css } from 'styled-components';

// Material-UI
import MuiDivider from '@material-ui/core/Divider';

// *************************************
// STYLED COMPONENTS                           
// *************************************

export const StyledDivider = styled(MuiDivider)`
  &.MuiDivider-root {
    background-color: ${(props) => props.color !== undefined ? props.theme.colors[props.color] : props.theme.colors.greyLight};
    ${(props) => props.padding && css`padding: ${(props) => props.padding};`};
    ${(props) => props.margin && css`margin: ${(props) => props.margin};`};
  }
`;